import { Box, Radio, RadioProps } from '@mantine/core';

export type RadioBoxProps = RadioProps;

export const RadioBox: React.FC<RadioBoxProps> = ({ checked, ...props }) => (
  <Box
    component="label"
    sx={theme => ({
      width: '100%',
      background: checked ? theme.colors.violet[1] : theme.colors.white,
      border: checked
        ? `solid 1px ${theme.colors.violet[0]}`
        : `solid 1px ${theme.colors.gray[3]}`,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing.sm,
      padding: theme.spacing.sm,
      borderRadius: theme.radius.sm,
      '&:hover': {
        cursor: 'pointer',
      },
    })}
  >
    <Radio checked={checked} {...props} />
  </Box>
);
